import {BasicCartItem} from 'components/common/BasicCartItem'
import {Frame} from 'components/system/Frame'
import {Ventrata} from 'types'
import {formatAvailabilityId} from 'utils/formatAvailabilityId'

type Props = {
  booking: Ventrata.Booking
}

export const CartItem = ({booking}: Props) => {
  return (
    <BasicCartItem
      booking={booking}
      render={(cartItemData) => {
        return (
          <div className="flex flex-col gap-4">
            <div className="text-french-blue-030 text-lg font-bold">
              {formatAvailabilityId(booking.availabilityId, 'dddd, MMM DD')}
            </div>
            <Frame className="flex gap-4 w-full">{cartItemData}</Frame>
          </div>
        )
      }}
    />
  )
}
